import * as React from 'react';
import camelCase from 'lodash/camelCase';

import InputControl from '../InputControl/InputControl';
import { IInputFieldProps } from '../TextInput/InputTextField';

import SelectOptionItem from './SelectOptionItem';
import SelectInput from './SelectInput';
import { ISelectInputProps } from './common';

interface IInputSelectField extends IInputFieldProps, ISelectInputProps {
  children: Array<React.ReactElement<HTMLOptionElement>> | React.ReactElement<HTMLOptionElement>;
  placeHolder?: string;
}

// exporting here is a work around for this issue https://github.com/microsoft/tslint-microsoft-contrib/issues/667
export const InputSelectField = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement> & IInputSelectField>((
  props, ref
) => {
  const {
    children,
    errorMsgs,
    helperText,
    inputProps,
    label,
    placeHolder,
    tooltipProps,
    maxWidth,
  } = props;
  React.Children.forEach(children, (child: JSX.Element) => {
    if (child && child.type.displayName !== 'SelectOptionItem') {
      throw new Error(`Children should be of type SelectOptionItem.`);
    }
  });
  const isDisabled = !!(inputProps && inputProps.disabled);
  const isOptional: boolean = !!(inputProps && inputProps.required === false);
  const selectId: string = camelCase(`${label}`);

  return (
    <InputControl
      errorMsgs={errorMsgs}
      helperText={helperText}
      isDisabled={isDisabled}
      isOptional={isOptional}
      inputProps={inputProps}
      label={label}
      tooltipProps={tooltipProps}
      maxWidth={maxWidth}
    >
      <SelectInput
        ref={ref}
        selectId={selectId}
        inputProps={inputProps}
      >
        {placeHolder && (
          <SelectOptionItem value='' key='placeHolder' optionProps={{ disabled: true, hidden: true }}>
            {placeHolder}
          </SelectOptionItem>
        )}
        {children}
      </SelectInput>
    </InputControl>
  );
});

export default InputSelectField;
